export const tier = s => (s >= 75 ? 'Hot' : s >= 40 ? 'Warm' : 'Cold')
const COLOR = { Hot: '#DC3545', Warm: '#FFC107', Cold: '#6c757d' }
const TEXT = { Hot: '#B02A37', Warm: '#8A6100', Cold: '#495057' }
/* Lead score presentation */
export default function LeadScore({ score, large }) {
  const t = tier(score)
  return (<div>
    <div className={large ? 'display-6 fw-bold' : 'fw-semibold'}>{score}<small className="text-muted fs-6">/100</small></div>
    <div className="progress my-1" style={{ height: large ? 10 : 6 }}><div className="progress-bar" style={{ width: score + '%', background: COLOR[t] }} /></div>
    <span className="badge-soft" style={{ background: COLOR[t] + '22', color: TEXT[t] }}>{t}</span></div>)
}
